
import backIcon from './backIcon.png';
import newChat from './newChat.png';
import chatMenu from './chatMenu.png'
import addIcon from './addIcon.png'
import send from './send.png'
import doctorIcon from './doctorIcon.png'
import groupIcon from './groupIcon.png'
import emergencyIcon from './emergencyIcon.png'
import chatbotIconDark from './chatbubble.png';
import chatbotIconLight from './chatbubble.png';
import promptIcon from './prompt.png';


export const Icons = {
  back: backIcon,
  newChat: newChat,
  chatMenu: chatMenu,
  add: addIcon,
  send: send,
  doctor: doctorIcon,
  group: groupIcon,
  emergency: emergencyIcon,
  chatbotDark:chatbotIconDark,
  chatbotLight:chatbotIconLight,
  prompt :promptIcon
};

